<template>
    <div class="content">
        <Banner></Banner>
        <Menu></Menu>
        <HotRoute></HotRoute>
        <Polar></Polar>
        <Theme></Theme>
        <PolarClub></PolarClub>
        <Address></Address>
    </div>
</template>

<script>
import Banner from './banner'
import Menu from './menu'
import HotRoute from './hotRoute'
import Polar from './polar'
import Theme from './theme'
import PolarClub from './polarClub'
import Address from './address'
export default {
  data () {
    return {
      name: ''
    }
  },
  components: {
    Banner,
    Menu,
    HotRoute,
    Polar,
    Theme,
    PolarClub,
    Address
  }
}
</script>

<style scoped lang="scss">
.content {
    width: 100%;
    position: relative;
    .header {
        width: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/Index/index.vue